<template lang="html">
	<div class="omapi-plugin-header">
		<div class="omapi-plugin-banner" id="omwp-plugin-banner">
			<div class="omapi-plugin-banner__wrapper">
				<div class="omapi-plugin-banner__logo">
					<img src="../../assets/images/logo-om.svg" alt="OptinMonster Logo">
					<span class="omapi-plugin-banner__page">{{ bannerTitle }}</span>
					<span v-if="betaVersion">&nbsp;&mdash;&nbsp;<strong>Beta Version: {{ betaVersion }}</strong></span>
				</div>
				<ul class="omapi-plugin-banner__icons">
					<li id="om-notifications-trigger">
						<button
							class="unbutton omapi-plugin-banner__icon omapi-inbox"
							:class="hasNotifications ? 'youve-got-mail' : ''"
							type="button"
							@click.prevent="showNotifications"
						>
							<svg-inbox solid="hover"/>
							<span v-if="hasNotifications" class="om-pulse"></span>
						</button>

						<notifications-drawer :show="notificationsOpen"/>
					</li>
					<li>
						<a class="omapi-plugin-banner__icon omapi-help help-white" target="_blank" rel="noopener" :href="$urls.docs('', 'BannerHelpButton')"></a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script lang="js">
import { mapState, mapGetters } from 'vuex'
import { getAppData } from '@/utils'

export default  {
	data () {
		return {
			notificationsOpen : false,
		}
	},
	mounted () {
		// We only need to fetch notifications here if it isn't already going to happen in the fetchMe route.
		if (this.shouldFetchUser || !this.connected) {
			this.$store.dispatch('notifications/fetch')
		}
		this.$bus.$on('notificationsToggle', this.showNotifications)
	},
	beforeDestroy () {
		this.$bus.$off('notificationsToggle', this.showNotifications)
	},
	computed : {
		...mapGetters([ 'shouldFetchUser', 'connected' ]),
		...mapState('notifications', [ 'notifications' ]),
		...mapState([ 'bannerTitle' ]),
		betaVersion () {
			return getAppData('betaVersion')
		},
		hasNotifications () {
			return 0 < this.notifications.length
		},
	},
	methods : {
		showNotifications () {
			this.notificationsOpen = !this.notificationsOpen
		},
	},
}

</script>
<style lang="scss">
	@import '../../assets/scss/variables';
	#om-notifications-trigger {
		.fade-enter-active, .fade-leave-active {
			transition: opacity .2s;
		}
		.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
			opacity: 0;
		}
	}

	.youve-got-mail {
		position: relative;
		&:active,
		&:focus,
		&:hover {
			.om-pulse:after {
				display: none;
			}
		}
	}

	.om-pulse {
		text-align: center;
		cursor: pointer;
		display: inline-block;
		width: 10px;
		height: 10px;
		top: -5px;
		right: -7px;
		border: 3px solid $color_blue-primary;
		border-radius: 100%;
		background-color: #df2a4a;
		position: absolute;
		&:after {
			content: '';
			position: absolute;
			top: -2px;
			left: -2px;
			width: 13px;
			height: 13px;
			background-color: #df2a4a;
			border-radius: 100%;
			z-index: 0;
			animation: ompulse 10s infinite;
			will-change: transform;
		}
	}

	@keyframes ompulse {
		0% { transform: scale(1); opacity: 1; }
		20% { transform: scale(2); opacity: 0; }
		100% { transform: scale(2); opacity: 0; }
	}
</style>
